<template>
  <div class="bg-white fluid-container position-fixed-top border rounded shadow col-lg-8 p-lg-4 p-1">
    

    <b-row > 
    <b-col class="col-12 col-lg-8">
      <h3 >Edit Performance</h3>
      </b-col>
        <b-col>
            Select Performance:
            <select class="form-control" v-on:change="setPerformance(performanceID)" v-model="performanceID">
                <option value=""> -- Select Performance -- </option>
                <option  class="bg-primary" v-for="performance in performances" :key="performance.id"  :value="performance.performance_id">
                    {{performance.performance_id}}
                </option>
            </select>
        
        </b-col>
   
  
    </b-row>
    
    <b-form>
     
      <b-form-group v-for="(performance,key) in form" v-bind:key="performance.id">
        <div v-if="key.split('?')[1] != 'hide'" class="text-capitalize">
            {{ key.split('?')[0].replace('_', ' ' ) }}
        </div>
       
        <component :is="
            key.split('?')[1] == 'area' ? 'b-form-textarea' :
            key.split('?')[1] == 'hide' ? '' :
            key.split('?')[1] == 'check' ? 'b-form-checkbox' : 'b-form-input' "
            rows="12"
            max-rows="15"
          :id="'input-' . key"
          v-model="form[key]"
         v-on:change="update(key)" 
         
        ></component>

        <!-- <div class='col-md-6  col-lg-4 p-3 mt-3 border rounded shadow' v-if="key.split('?')[1] == 'area'" v-html="'<h5 >Order form Preview</h4>' + form[key]"></div> -->
        <div class="col-md-6  col-lg-4 mt-3"  v-if="key.split('?')[1] == 'img'" >
            <img class='img-fluid' :src='baseURL + form[key]' />
        </div>
      </b-form-group>
      
      <b-alert class="m-2"
      :show="dismissCountDown"
      dismissible
      fade
      :variant="variant"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{responseMSG}}
    </b-alert>
    
      <b-button v-on:click="cancel" variant="primary" class="ml-2">Close</b-button>
      <b-button v-on:click="_delete" variant="danger" class="ml-2">Delete Performance</b-button>
    </b-form>
   
    


  </div>
</template>

<script>
/* eslint-disable */ 
  export default {
    name: "performanceEdit",
    data() {
      return {
        form: {},
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
        responseMSG: '',
        baseURL: 'https://www.aperturefilms.com.au',
        performances: {},
        performanceID: ''
      }
    },
    props: {
      authenticated: {}
    }, 
    methods: {
    setPerformance(_performance) {

        let currentObj = this;
        let params = new URLSearchParams();
        params.append('task', 'setPerformance');
        params.append('performance_id', _performance);
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    currentObj.getPerformance()
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
    listPerformance() {
        let currentObj = this;
        let params = new URLSearchParams();
        params.append('field', 'all');
        params.append('task', 'listPerformances');
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    
                    currentObj.performances = response.data
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
    getPerformance() {
        let currentObj = this;
        let params = new URLSearchParams();
        params.append('task', 'getPerformance');
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    currentObj.form = response.data[0]
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
      update(el){
            let currentObj = this;
            let params = new URLSearchParams();
           if (el.split('?')[1] == 'check') {
                this.form[el] = !this.form[el]  
            }
           params.append('value', this.form[el])
            el = el.split('?')[0]
            params.append('field', el);
            params.append('id', this.form['id?hide'])
            params.append('task', 'editPerformance');
            this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    console.log(response.data) 
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
      _delete(){

            let currentObj = this;
            let params = new URLSearchParams();
            params.append('id', this.form['id?hide'])
            params.append('task', 'deletePerformance');
            this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {

                    if (response.data.success) {
                        
                        currentObj.form = {}
                        currentObj.showAlert('info', 'Performance Deleted')
                        
                    }
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
      cancel(evt) {
          this.$emit('menuItem', false)
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert(type, msg) {
        this.responseMSG = msg
        this.variant = type
        this.dismissCountDown = this.dismissSecs
      }

    },
    mounted() {
        this.listPerformance()
        this.getPerformance()
    }
  }
</script>
<style scoped>
.fluid-container {
    margin: 0 auto 0;
     margin-top: 110px;


}
</style>